export default __webpack_public_path__ + "static/media/igloo_4.2e617f97.jpg";